var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 48 48",
    height: "48px",
    id: "Layer_1",
    viewBox: "0 0 48 48",
    width: "48px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M42,43L42,43H6l0,0c-2.762,0-5-2.238-5-5V15c0-0.552,0.447-1,1-1l0,0h3V9  c0-2.209,1.791-4,4-4h10c2.209,0,4,1.791,4,4v1h23c0.553,0,1,0.448,1,1v27C47,40.762,44.762,43,42,43z M3,16v22l0,0  c0,1.657,1.344,3,3,3h32.022C37.39,40.162,37,39.131,37,38V16H3z M45,12H21V9c0-1.104-0.896-2-2-2H9C7.896,7,7,7.896,7,9v5h31l0,0  c0.278,0,0.529,0.114,0.71,0.298C38.889,14.479,39,14.726,39,15c0,0,0,0,0,0v23c0,1.657,1.343,3,3,3s3-1.343,3-3V12z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.a9eb3a0efcb4d2536cea446b2a26ea0d.svg";
export { ForwardRef as ReactComponent };